import CryptoJS from "crypto-js";

/**
 * Use this to make a Base64 encoded string URL friendly,
 * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
 * characters are removed.
 */
export const base64EncodeUrl = str => {
  return str
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

/**
 * Use this to recreate a Base64 encoded string that was made URL friendly.
 */
export const base64DecodeUrl = str => {
  str = (str + "===").slice(0, str.length + (str.length % 4));
  return str.replace(/-/g, "+").replace(/_/g, "/");
};

/**
 * Generates a JWT token by applying the following on both header + payload
 *
 * HMACSHA256(
 *   base64UrlEncode(header) + "." +
 *   base64UrlEncode(payload),
 *   secret
 * )
 */
export const createJWT = (header, payload, secret) => {
  // Clear all whitespaces
  const headerClean = JSON.stringify(JSON.parse(header));
  const payloadClean = JSON.stringify(JSON.parse(payload));

  const wordArrayHeader = CryptoJS.enc.Utf8.parse(headerClean);
  const wordArrayPayload = CryptoJS.enc.Utf8.parse(payloadClean);

  // Base64UrlEncode header + payload
  const base64Header = base64EncodeUrl(
    CryptoJS.enc.Base64.stringify(wordArrayHeader)
  );
  const base64Payload = base64EncodeUrl(
    CryptoJS.enc.Base64.stringify(wordArrayPayload)
  );

  // HMACSHA256
  const data = base64Header + "." + base64Payload;
  const hash = CryptoJS.HmacSHA256(data, secret);

  // Base64UrlEncode hash
  const base64Hash = base64EncodeUrl(CryptoJS.enc.Base64.stringify(hash));
  const token = data + "." + base64Hash;

  return token;
};
